import React from 'react';
import { Card, CardContent, Typography, Grid, Icon } from '@material-ui/core';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import SecurityIcon from '@material-ui/icons/Security';
import SettingsIcon from '@material-ui/icons/Settings';
import AssignmentIcon from '@material-ui/icons/Assignment';
import BusinessIcon from '@material-ui/icons/Business';
import PersonIcon from '@material-ui/icons/Person';
import PeopleIcon from '@material-ui/icons/People';
import FormSwitch from '../../controls/components/switch';




const UserRoleCard = ({ role, isEnabled, onToggle }) => {
    const handleToggle = (e) => {
        onToggle(role.Id);
    };

    const getBackgroundColor = (accessLevel) => {
        switch (accessLevel) {
            case 'Very High':
                return '#ffcccc'; // Light red
            case 'High':
                return '#ffebcc'; // Light orange
            case 'Medium':
                return '#ffffcc'; // Light yellow
            case 'Low':
                return '#ccffcc'; // Light green
            default:
                return '#ffffff'; // White
        }
    };

 

    return (
        <Card style={{ marginBottom: '10px',  padding: '10px' }}>
            <CardContent style={{ padding: '10px' }}>
                <Grid container alignItems="center">
                    <Grid item xs={2} style={{ display: 'flex', justifyContent: 'center', }}>
                        <Icon>{role.Icon}</Icon>
                    </Grid>
                    <Grid item xs={8}>
                        <Typography variant="body1" style={{ fontWeight: 'bold' }}>{role.RoleName}</Typography>
                        <Typography variant="body2" color="textSecondary">{role.Description}</Typography>
                        {role.ErrorMessage && <Typography variant="body2" color="error" style={{ fontWeight: 'bold' }}>{role.ErrorMessage}</Typography>}
                    </Grid>
                    <Grid item xs={2} >
                        <FormSwitch
                            checked={isEnabled}
                            handleFieldValue={() => handleToggle(role)}
                            color="primary"
                            value={isEnabled ? 'A' : 'I'}
                            extraProps={{
                                transformProps: {
                                    'I': false,
                                    A: true,
                                    'true': 'A',
                                    'false': 'I'
                                },
                            }}
                        />
                        {/* <Switch
                            checked={isEnabled}
                            onChange={handleToggle}
                            color="primary"
                        /> */}
                    </Grid>
                </Grid>                            
            </CardContent>
            
        </Card>
    );
};

export default UserRoleCard;